/**
 *  A user as returned by /json/admin/loadUserGroups and /json/admin/loadUsers.
 *  Mirrors com.viztrend.integration.admin.model.User.
 *
 *  Deliberately separate from Interfaces/User.ts — that one is the trimmed shape
 *  the data viewer uses and does not carry any of the administration fields.
 */
export interface AdminUser {
  id: number;
  userName: string;
  fullName: string | null;
  email: string | null;
  phoneNumber: string | null;
  roles: string;
  groupId: number;
  active: boolean;
  lastLogin: string | null;

  password?: string;
  locationIds: number[] | null;
  locationNames: string[] | null;

  superUserGroup: boolean;
  responsibleUser: boolean;
  sendInvitationEmail: boolean;

  usesSso: boolean;
  appleSignin: boolean;
  samlSso: boolean;
  aadSso: boolean;

  newDataNotification: boolean;
  updatedDataNotification: boolean;
  updatedCreatedDataNotification: boolean;
  newDataFrequency: string | null;
  updatedDataFrequency: string | null;
  sendReportTo: string | null;

  accessSharedDataOnly: boolean;
  twoFactorAuth: string | null;
}

export type AdminUsers = AdminUser[];

export type AdminUserDraft = Partial<AdminUser> & Pick<AdminUser, 'userName' | 'groupId'>;

export interface AdminUsersState {
  loaded: boolean;
  collection: AdminUsers;
}

/** The four mutually exclusive single sign-on flags. */
export const SSO_FIELDS = ['usesSso', 'appleSignin', 'samlSso', 'aadSso'] as const;
export type SsoField = typeof SSO_FIELDS[number];

/** Roles that consume an "office user" seat rather than a field seat. */
export const OFFICE_ROLES = ['admin,modeler', 'modeler', 'ordinary'];
